import React, { useState } from 'react';
import './MobileMenu.scss';
import { Link, useNavigate } from 'react-router-dom';

const MobileMenu = () => {
    const [activeMenu, setActiveMenu] = useState(false);
    const navigate = useNavigate();

    const openMenu = () => {
        setActiveMenu(true);
        document.body.classList.add('has-active-menu');
    };

    const closeMenu = () => {
        setActiveMenu(false);
        document.body.classList.remove('has-active-menu');
    };


    return (
        <div className="standard mobile-menu">
            <div className='mobile-menu__icons'>
            </div>

            <ul className={'mobile-menu__links' + (activeMenu ? ' active' : '')}>
                <h3 className='mobile-menu__title'>Menu</h3>
                <div className='mobile-menu__line' />

                <Link className='standard__link' to='/products' onClick={closeMenu}>
                    <li className=" mobile-menu__list-item">Products</li>
                </Link>
                <Link className='standard__link' to='/import-products' onClick={closeMenu}>
                    <li className=" mobile-menu__list-item">Import products</li>
                </Link>




            </ul>
            <img
                onClick={closeMenu}
                className={'mobile-menu__close-icon' + (activeMenu ? ' active' : '')}
                src="/images/close-icon.png"
                alt="close Icon"
            />
        </div>
    );
};

export default MobileMenu;
